export default function DOM_Node() {
  return (
    <div>
      <h1>DOM_Node</h1>
      <p>This is the DOM_Node component.</p>
    </div>
  );
}